export default __webpack_public_path__ + "static/heroSectionMobImg-8dd84ec960c61e01a938ec81f8a6d58d.webp";